import { rep } from '@rep-protocol/sdk'

// Runtime configuration injected by the REP gateway (or by the `@rep-protocol/vite`
// dev plugin during `vite dev`). See `.rep.yaml`.
//
// Public values remain lazy synchronous getters. Sensitive values use async
// helpers because REP fetches a session key and decrypts them client-side.
export const env = {
  get FIREBASE_AUTH_DOMAIN() {
    return rep.get('FIREBASE_AUTH_DOMAIN', '')
  },
  get FIREBASE_PROJECT_ID() {
    return rep.get('FIREBASE_PROJECT_ID', '')
  },
  get FIREBASE_STORAGE_BUCKET() {
    return rep.get('FIREBASE_STORAGE_BUCKET', '')
  },
  get FIREBASE_MESSAGING_SENDER_ID() {
    return rep.get('FIREBASE_MESSAGING_SENDER_ID', '')
  },
  get FIREBASE_APP_ID() {
    return rep.get('FIREBASE_APP_ID', '')
  },
  get FIREBASE_USE_EMULATOR() {
    return rep.get('FIREBASE_USE_EMULATOR', 'false')
  },
  get API_URL() {
    return rep.get('API_URL', 'http://localhost:8000')
  },
  get APP_URL() {
    return rep.get('APP_URL', '')
  },
  get POSTHOG_HOST() {
    return rep.get('POSTHOG_HOST', 'https://eu.i.posthog.com')
  },
  get SENTRY_ENVIRONMENT() {
    return rep.get('SENTRY_ENVIRONMENT', 'development')
  },
  getFirebaseApiKey() {
    return rep.getSecure('FIREBASE_API_KEY')
  },
  getPostHogKey() {
    return rep.getSecure('POSTHOG_KEY').catch(() => '')
  },
  getSentryDsn() {
    return rep.getSecure('SENTRY_DSN').catch(() => '')
  },
}

export type Env = typeof env
